<template>
    <div
        id="main-wrapper"
        class="attendee-wrapper"
        :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'"
    >
        <NavbarDark />

        <!-- Exhibit Banner -->
        <div
            v-if="exhibit?.banner"
            class="exhibit-page-banner"
        >
            <img
                :src="exhibit.banner"
                :alt="exhibit.name || 'Exhibit Banner'"
                class="exhibit-banner-image"
            />

            <div class="exhibit-banner-overlay"></div>
        </div>

        <div
            v-else
            class="exhibit-page-banner exhibit-banner-placeholder"
        >
            <div class="exhibit-banner-placeholder-icon">
                <i class="fa-solid fa-building"></i>
            </div>
        </div>

        <div class="bg-light pb-4">

            <div class="container-fluid">

                <div class="row">

                    <!-- Exhibit Title -->
                    <div
                        v-if="exhibit?.name"
                        class="exhibit-title"
                    >
                        <div class="container">
                            <h2>{{ exhibit.name }}</h2>
                        </div>
                    </div>

                    <div class="col-lg-12 col-md-12">

                        <div class="dashboard-wraper w-100">
                            <p class="text-center text-danger">{{t("You can add a maximum of 5 employees")}}</p>
                            <div class="form-submit">

                                <div class="submit-section">
                                    <!-- Stand -->
                                    <div class="row">

                                        <div class="form-group col-md-6">
                                            <label class="mb-2">
                                                {{ t("Stand") }}
                                                <span class="text-danger">*</span>
                                            </label>
                                            <div
                                                class="custom-select-wrapper"
                                                ref="standSelectRef"
                                            >

                                                <button
                                                    type="button"
                                                    class="form-control custom-select-button"
                                                    :class="{
                                                        'is-open': standDropdownOpen,
                                                        'is-invalid': errors.stand_id?.length
                                                    }"
                                                    @click="toggleStandDropdown"
                                                >

                                                    <span v-if="selectedStand">
                                                        {{ selectedStand.name }}
                                                    </span>

                                                    <span
                                                        v-else
                                                        class="text-muted"
                                                    >
                                                        {{ t("Select Stand") }}
                                                    </span>

                                                </button>

                                                <!-- Dropdown -->
                                                <div
                                                    v-if="standDropdownOpen"
                                                    class="custom-select-dropdown"
                                                >

                                                    <!-- Search -->
                                                    <div class="custom-select-search">

                                                        <input
                                                            ref="standSearchInput"
                                                            v-model="standSearch"
                                                            type="text"
                                                            class="form-control"
                                                            :placeholder="t('Search Stand')"
                                                            @input="searchStands"
                                                            @click.stop
                                                        />

                                                    </div>

                                                    <!-- Loading -->
                                                    <div
                                                        v-if="standsLoading"
                                                        class="custom-select-message"
                                                    >
                                                        {{ t("Loading...") }}
                                                    </div>

                                                    <!-- Empty -->
                                                    <div
                                                        v-else-if="stands.length === 0"
                                                        class="custom-select-message"
                                                    >
                                                        {{ t("No stands found") }}
                                                    </div>

                                                    <!-- Options -->
                                                    <div
                                                        v-else
                                                        class="custom-select-options"
                                                    >

                                                        <button
                                                            v-for="stand in stands"
                                                            :key="stand.id"
                                                            type="button"
                                                            class="custom-select-option"
                                                            :class="{
                                                                active: form.stand_id == stand.id
                                                            }"
                                                            @click="selectStand(stand)"
                                                        >
                                                            {{ stand.name }}
                                                        </button>

                                                    </div>

                                                </div>

                                            </div>

                                            <small
                                                v-if="errors.stand_id?.[0]"
                                                class="text-danger"
                                            >
                                                {{ errors.stand_id[0] }}
                                            </small>

                                        </div>

                                    </div>

                                    <!-- Employees -->
                                    <div class="employees-wrapper mt-4">

                                        <div
                                            v-for="(employee, index) in form.employees"
                                            :key="index"
                                            class="employee-row mb-3"
                                        >

                                            <div class="row align-items-start">

                                                <!-- Employee Number -->
                                                <div class="col-md-1">

                                                    <div class="employee-number">
                                                        {{ index + 1 }}
                                                    </div>

                                                </div>


                                                <!-- Name -->
                                                <div class="form-group col-md-5">

                                                    <label class="mb-2">
                                                        {{ t("Name") }}
                                                    </label>

                                                    <input
                                                        v-model="employee.name"
                                                        type="text"
                                                        class="form-control"
                                                        :class="{
                                                            'is-invalid':
                                                                errors[`employees.${index}.name`]?.length
                                                        }"
                                                        :placeholder="t('Employee Name')"
                                                    />

                                                    <small
                                                        v-if="errors[`employees.${index}.name`]?.[0]"
                                                        class="text-danger"
                                                    >
                                                        {{ errors[`employees.${index}.name`][0] }}
                                                    </small>

                                                </div>


                                                <!-- Job -->
                                                <div class="form-group col-md-5">

                                                    <label class="mb-2">
                                                        {{ t("Job Title") }}
                                                    </label>

                                                    <input
                                                        v-model="employee.job"
                                                        type="text"
                                                        class="form-control"
                                                        :class="{
                                                            'is-invalid':
                                                                errors[`employees.${index}.job`]?.length
                                                        }"
                                                        :placeholder="t('Job Title')"
                                                    />

                                                    <small
                                                        v-if="errors[`employees.${index}.job`]?.[0]"
                                                        class="text-danger"
                                                    >
                                                        {{ errors[`employees.${index}.job`][0] }}
                                                    </small>

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                    <!-- General Employees Error -->
                                    <div
                                        v-if="errors.employees?.[0]"
                                        class="text-danger mb-3"
                                    >
                                        {{ errors.employees[0] }}
                                    </div>

                                    <!-- Save -->
                                    <div class="row">

                                        <div class="col-12 mt-3">

                                            <button
                                                type="button"
                                                class="btn btn-primary"
                                                :disabled="isSubmitting"
                                                @click="submit"
                                            >

                                                <span v-if="isSubmitting">
                                                    {{ t("Saving...") }}
                                                </span>

                                                <span v-else>
                                                    {{ t("Save") }}
                                                </span>

                                            </button>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

        <FooterTop :bg="'theme-bg'" />
        <FooterDark />
        <ScrollToTop />

    </div>
</template>


<script setup>

import FooterDark from '@/components/footer/footer-dark.vue'
import FooterTop from '@/components/footer/footer-top.vue'
import NavbarDark from '@/components/navbar/navbar-dark.vue'
import ScrollToTop from '@/components/scroll-to-top.vue'

import {
    ref,
    onMounted,
    watch,
    onBeforeUnmount
} from 'vue'

import { useRoute } from 'vue-router'
import axios from 'axios'
import { useToast } from 'vue-toastification'
import { useI18n } from 'vue-i18n'


const toast = useToast()

const {
    t,
    locale
} = useI18n()

const route = useRoute()


/*State*/

const isSubmitting = ref(false)

const exhibit = ref(null)

const exhibitLoading = ref(true)

const stands = ref([])

const standsLoading = ref(false)

const standSearch = ref('')

const standDropdownOpen = ref(false)

const selectedStand = ref(null)

const standSelectRef = ref(null)

const standSearchInput = ref(null)

const errors = ref({})


/*Employees*/

const createEmployees = () => {

    return Array.from(
        { length: 5 },
        () => ({
            name: '',
            job: ''
        })
    )

}


/*Form*/

const form = ref({

    exhibit_code:
        route.params.code || '',

    stand_id:
        '',

    employees:
        createEmployees()

})


/*Fetch Exhibit*/

const fetchExhibit = async () => {

    try {

        exhibitLoading.value = true

        const code = route.params.code

        if (!code) {
            return
        }

        const response = await axios.get(
            `/detail/exhibit/${code}`,
            {
                params: {
                    lang: locale.value
                }
            }
        )

        if (response.data.success) {

            exhibit.value =
                response.data.data

        }

    } catch (error) {

        console.error(
            'Error fetching exhibit:',
            error
        )

        exhibit.value = null

    } finally {

        exhibitLoading.value = false

    }

}


/*Fetch Stands*/

const fetchStands = async (search = '') => {

    const code = route.params.code

    if (!code) {
        return
    }

    try {

        standsLoading.value = true

        const response = await axios.get(
            `/exhibits/${code}/stands`,
            {
                params: {
                    lang: locale.value,
                    search: search
                }
            }
        )

        if (response.data.success) {

            stands.value =
                response.data.data

            if (form.value.stand_id) {

                const found =
                    stands.value.find(
                        stand =>
                            stand.id ==
                            form.value.stand_id
                    )

                if (found) {

                    selectedStand.value =
                        found

                }

            }

        }

    } catch (error) {

        console.error(
            'Error fetching stands:',
            error
        )

        stands.value = []

    } finally {

        standsLoading.value = false

    }

}


/*Stand Search*/

let standSearchTimeout = null

const searchStands = () => {

    clearTimeout(
        standSearchTimeout
    )

    standSearchTimeout =
        setTimeout(() => {

            fetchStands(
                standSearch.value
            )

        }, 300)

}


/*Open / Close Stand Dropdown*/

const toggleStandDropdown = async () => {

    standDropdownOpen.value =
        !standDropdownOpen.value

    if (!standDropdownOpen.value) {
        return
    }

    standSearch.value = ''

    await fetchStands()

    setTimeout(() => {

        standSearchInput.value?.focus()

    }, 50)

}


/*Select Stand*/

const selectStand = (stand) => {

    form.value.stand_id =
        stand.id

    selectedStand.value =
        stand

    standDropdownOpen.value =
        false

    standSearch.value = ''


    if (errors.value.stand_id) {

        delete errors.value.stand_id

    }

}


/*Click Outside*/

const handleClickOutside = (event) => {

    if (
        standSelectRef.value &&
        !standSelectRef.value.contains(
            event.target
        )
    ) {

        standDropdownOpen.value =
            false

    }

}
const validateEmployees = () => {

    let valid = true

    form.value.employees.forEach(
        (employee, index) => {

            const name =
                employee.name?.trim()

            const job =
                employee.job?.trim()


            if (!name && !job) {
                return
            }


            if (!name) {

                errors.value[
                    `employees.${index}.name`
                ] = [
                    t("Name is required")
                ]

                valid = false

            }


            if (!job) {

                errors.value[
                    `employees.${index}.job`
                ] = [
                    t("Job Title is required")
                ]

                valid = false

            }

        }
    )

    const hasEmployees =
        form.value.employees.some(
            employee =>
                employee.name?.trim() ||
                employee.job?.trim()
        )

    if (!hasEmployees) {

        errors.value.employees = [
            t("Please enter at least one employee")
        ]

        valid = false

    }

    return valid

}


/*Submit Bulk Employees*/

const submit = async () => {

    if (isSubmitting.value) {
        return
    }

    errors.value = {}
    if (!form.value.stand_id) {

        errors.value.stand_id = [
            t("Please select a stand")
        ]

        toast.error(
            t("Please select a stand")
        )

        return

    }

    if (!validateEmployees()) {

        toast.error(
            t("Please complete the employee information")
        )

        return

    }

    const employees =
        form.value.employees
            .filter(employee => {

                return (
                    employee.name?.trim() ||
                    employee.job?.trim()
                )

            })
            .map(employee => ({

                name:
                    employee.name.trim(),

                job:
                    employee.job.trim()

            }))

    if (employees.length > 5) {

        toast.error(
            t("You can add a maximum of 5 employees")
        )

        return

    }


    isSubmitting.value = true


    try {
        const response = await axios.post(
            '/employees',
            {
                exhibit_code:
                    form.value.exhibit_code,

                stand_id:
                    form.value.stand_id,

                employees:
                    employees
            },
            {
                params: {
                    lang: locale.value
                }
            }
        )


        if (response.data.success) {

            toast.success(
                t("Employees saved successfully")
            )


            form.value = {

                exhibit_code:
                    route.params.code || '',

                stand_id:
                    '',

                employees:
                    createEmployees()

            }


            selectedStand.value =
                null

            standSearch.value =
                ''

            errors.value = {}

        }

    } catch (error) {


        if (
            error.response?.status === 422
        ) {

            const validationErrors =
                error.response.data?.errors

            if (validationErrors) {

                errors.value =
                    validationErrors

                const firstError =
                    Object.values(
                        validationErrors
                    )[0]?.[0]

                if (firstError) {

                    toast.error(
                        firstError
                    )

                }

            } else if (
                error.response.data?.message
            ) {

                toast.error(
                    error.response.data.message
                )

            }

            return

        }


        toast.error(
            error.response?.data?.message ||
            t("Failed to save employees")
        )

        console.error(
            'Error saving employees:',
            error
        )

    } finally {

        isSubmitting.value = false

    }

}


/*Mounted*/

onMounted(async () => {

    document.addEventListener(
        'click',
        handleClickOutside
    )

    await fetchExhibit()

    await fetchStands()

})


/*Before Unmount*/

onBeforeUnmount(() => {

    document.removeEventListener(
        'click',
        handleClickOutside
    )

    clearTimeout(
        standSearchTimeout
    )

})


/*Locale Change*/

watch(
    locale,
    async () => {

        await fetchExhibit()

        await fetchStands(
            standSearch.value
        )

        if (form.value.stand_id) {

            selectedStand.value =
                stands.value.find(
                    stand =>
                        stand.id ==
                        form.value.stand_id
                ) || null

        }

    }
)

</script>


<style>

.exhibit-page-banner {
    position: relative;
    width: 100%;
    height: clamp(180px, 25vw, 420px);
    overflow: hidden;
    background: #17232c;
}

.exhibit-banner-image {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    object-position: center;
}

.exhibit-banner-overlay {
    position: absolute;
    inset: 0;

    background:
        linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0.05),
            rgba(0, 0, 0, 0.55)
        );
}

.exhibit-title {
    width: 100%;
    padding: 20px 0;
}

.exhibit-title h2 {
    margin: 0;
    text-align: center;
    color: #6A715D;
    font-size: 28px;
    font-weight: 700;
}


/* No banner */

.exhibit-banner-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
}

.exhibit-banner-placeholder-icon {
    width: 70px;
    height: 70px;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 50%;

    background: rgba(255, 255, 255, 0.08);

    color: #ffffff;
    font-size: 28px;
}


/* Custom Stand Select */

.custom-select-wrapper {
    position: relative;
    width: 100%;
}

.custom-select-button {
    display: flex;
    align-items: center;
    justify-content: space-between;

    text-align: start;

    background: #fff;
    cursor: pointer;

    border: 1px solid #ced4da;
}

.custom-select-button:hover {
    background: #fff;
}

.custom-select-button.is-open {
    border-color: #86b7fe;
}

.custom-select-dropdown {
    position: absolute;

    top: calc(100% + 4px);
    left: 0;
    right: 0;

    z-index: 1050;

    background: #fff;

    border: 1px solid #dee2e6;
    border-radius: 6px;

    box-shadow:
        0 5px 20px rgba(0, 0, 0, 0.12);

    overflow: hidden;
}

.custom-select-search {
    padding: 10px;
    border-bottom: 1px solid #eee;
}

.custom-select-options {
    max-height: 250px;
    overflow-y: auto;
}

.custom-select-option {
    display: block;

    width: 100%;

    padding: 10px 14px;

    border: 0;

    background: #fff;

    text-align: start;

    cursor: pointer;
}

.custom-select-option:hover {
    background: #f5f5f5;
}

.custom-select-option.active {
    background: #f0f2ed;
    font-weight: 600;
}

.custom-select-message {
    padding: 15px;

    text-align: center;

    color: #777;
}


/* Employee Rows */

.employee-row {
    padding: 15px;

    background: #fff;

    border: 1px solid #e5e5e5;

    border-radius: 8px;
}

.employee-number {
    width: 38px;
    height: 38px;

    display: flex;

    align-items: center;
    justify-content: center;

    margin-top: 31px;

    border-radius: 50%;

    background: #f0f2ed;

    color: #6A715D;

    font-weight: 700;
}


/* Mobile */

@media (max-width: 767px) {

    .employee-number {
        margin-top: 0;
        margin-bottom: 10px;
    }

}

@media (max-width: 575px) {

    .exhibit-title {
        padding: 15px 0;
    }

    .exhibit-title h2 {
        font-size: 19px;
    }

    .exhibit-page-banner {
        height: 150px;
    }

}

</style>